"use client";

import { useEffect, useState } from "react";
import { GoogleAnalytics } from "@next/third-parties/google";

const CONSENT_KEY = "codiaj-cookies-consent-v2";

export function AnalyticsWrapper() {
  const [allowAnalytics, setAllowAnalytics] = useState(false);
  const gaId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

  useEffect(() => {
    function checkConsent() {
      try {
        const stored = localStorage.getItem(CONSENT_KEY);
        if (stored) {
          const consent = JSON.parse(stored);
          setAllowAnalytics(!!consent.analytics);
        }
      } catch {
        // ignore
      }
    }

    checkConsent();

    // Listen for custom event from CookieBanner
    window.addEventListener("cookie-consent-updated", checkConsent);
    return () => window.removeEventListener("cookie-consent-updated", checkConsent);
  }, []);

  if (!allowAnalytics || !gaId) return null;

  return <GoogleAnalytics gaId={gaId} />;
}
